/* wsapi3-basics v1.0 */
/* Deploy Version 2026-09-16 18:46:47 */
/* wsapi3-basics — shim minimalista de $/jQuery, NÃO um clone da lib inteira.
   Cobre só os métodos realmente usados até agora — tanto pelos "apps nativos"
   que dependem de jQuery (WSAPP_js injetados via /store/layout/apps) quanto
   por conteúdo/scripts cadastrados no admin da loja (ex.: compre-junto), já
   que render.controller.ts injeta este shim fixo no início do <body> de toda
   página enquanto a migração pra tirar jQuery dos módulos não termina:

     - Favoritos: val(), addClass(), removeClass(), append(), remove(), $.ajax()
     - Selo "Tecnologia Webstore": append()
     - Botão flutuante do WhatsApp: append(), click()
     - Compre junto: each(), text()

   Se registra como window.$/window.jQuery só quando NENHUM dos dois já
   existe (`typeof window.$ === 'undefined'`) — ou seja, é inofensivo enquanto
   o <script src=".../jquery-atual-sec.js"> (injetado em render.controller.ts
   quando isLegacyLayout é true) continuar carregando ANTES deste módulo:
   o jQuery real assume window.$ primeiro e este arquivo vira no-op. Só passa
   a valer de fato quando esse script pra de ser injetado.

   etapa "*" (ver config.json) — precisa carregar antes de qualquer app que
   use $, igual wsapi3-apps.

   Se uma app nova (nativa ou instalada por uma loja específica) precisar de
   um método de jQuery que não está aqui, a chamada estoura um TypeError bem
   visível no console (propositalmente não vira no-op silencioso) — adicione
   o método aqui e atualize a lista de cobertura acima. */
(function () {
    if (typeof window.$ !== 'undefined' || typeof window.jQuery !== 'undefined') return;

    function WsBasics(selector) {
        if (!(this instanceof WsBasics)) return new WsBasics(selector);

        if (typeof selector === 'string') {
            this.els = Array.prototype.slice.call(document.querySelectorAll(selector));
        } else if (selector && selector.nodeType === 1) {
            this.els = [selector];
        } else if (selector && (selector instanceof NodeList || Array.isArray(selector))) {
            this.els = Array.prototype.slice.call(selector);
        } else {
            this.els = [];
        }

        this.length = this.els.length;
    }

    WsBasics.prototype.val = function (value) {
        if (value === undefined) {
            return this.els.length ? this.els[0].value : undefined;
        }
        this.els.forEach(function (el) { el.value = value; });
        return this;
    };

    WsBasics.prototype.addClass = function (classes) {
        var list = String(classes).split(/\s+/).filter(Boolean);
        this.els.forEach(function (el) { el.classList.add.apply(el.classList, list); });
        return this;
    };

    WsBasics.prototype.removeClass = function (classes) {
        var list = String(classes).split(/\s+/).filter(Boolean);
        this.els.forEach(function (el) { el.classList.remove.apply(el.classList, list); });
        return this;
    };

    WsBasics.prototype.append = function (content) {
        this.els.forEach(function (el) {
            if (typeof content === 'string') {
                el.insertAdjacentHTML('beforeend', content);
            } else if (content && content.nodeType === 1) {
                el.appendChild(content);
            }
        });
        return this;
    };

    WsBasics.prototype.remove = function () {
        this.els.forEach(function (el) {
            if (el.parentNode) el.parentNode.removeChild(el);
        });
        return this;
    };

    WsBasics.prototype.show = function () {
        this.els.forEach(function (el) { el.style.display = ''; });
        return this;
    };

    WsBasics.prototype.each = function (callback) {
        this.els.forEach(function (el, index) { callback.call(el, index, el); });
        return this;
    };

    WsBasics.prototype.text = function (value) {
        if (value === undefined) {
            return this.els.length ? this.els[0].textContent : undefined;
        }
        this.els.forEach(function (el) { el.textContent = value; });
        return this;
    };

    WsBasics.prototype.click = function (handler) {
        if (handler === undefined) {
            this.els.forEach(function (el) { el.click(); });
            return this;
        }
        this.els.forEach(function (el) { el.addEventListener('click', handler); });
        return this;
    };

    var wsBasics = function (selector) { return new WsBasics(selector); };

    // $.ajax — só o suficiente pro padrão usado nas apps: GET com querystring
    // já montada em `data`, callbacks beforeSend/success/error.
    wsBasics.ajax = function (opts) {
        opts = opts || {};
        var method = (opts.type || 'GET').toUpperCase();
        var url = opts.url || '';
        var data = opts.data;

        if (typeof opts.beforeSend === 'function') {
            try { opts.beforeSend(); } catch (e) { /* mesmo comportamento do jQuery: erro no beforeSend não aborta a chamada */ }
        }

        var fetchUrl = url;
        var fetchOpts = { method: method };

        if (data) {
            if (method === 'GET') {
                fetchUrl += (url.indexOf('?') >= 0 ? '&' : '?') + data;
            } else {
                fetchOpts.body = data;
                fetchOpts.headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
            }
        }

        fetch(fetchUrl, fetchOpts)
            .then(function (res) { return res.text(); })
            .then(function (text) {
                if (typeof opts.success === 'function') opts.success(text);
            })
            .catch(function (err) {
                if (typeof opts.error === 'function') opts.error(err);
            });
    };

    window.$ = wsBasics;
    window.jQuery = wsBasics;
})();
